const clinicType = 'vet';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const config = {
    clinicType,
    isProd,
    mixpanelToken: isProd
        ? 'cf4c559bb22f7ba78ba1667adc6bdbe4' // vet prod token
        : 'b9a4fc257db382b75fb35c9011ff6f98', // vet dev/staging token

    loginBanner: require('./assets/banners/loginPageBanner.png'),

    cetraBlueLogo: require('./assets/logos/cetra_blue.png'),

    cetraMobileLogo: require('./assets/logos/cetra_marque.png'),

    gtagId: process.env.REACT_APP_GTAG_ID || '',

    accountTypes: [
        {
            type: 'Free',
            title: 'Get started for free',
            description: 'Jump into Cetra with full access to our content and features. No card details. No limits. ',
        },
        {
            type: 'Professional',
            title: 'Unlock pro',
            description:
                'Get the most out of Cetra for just £9.99 per month. Enjoy unlimited digital sharing and printing, plus your own workspace to save, organise, and reuse customised handouts and diagrams.',
        },
        {
            type: 'Clinic',
            title: 'Power your whole clinic',
            description:
                'Invite team members onto Cetra at no extra cost. You’ll get everything in Pro, plus shared clinic access, bundled handouts, clinic branding, and powerful tools designed for growing teams.',
        },
    ],

    feedbackText:
        'We highly appreciate detailed information, as it plays a crucial role in fulfilling our mission of improving animal welfare through comprehensive veterinary knowledge.',

    landingPageUrl: 'https://www.cetravets.com',

    surveyUrl: 'https://forms.office.com/e/10XN2xgEJm',

    tsCsUrl: 'https://www.cetravets.com/legal/terms-of-service',

    privacyPolicyUrl: 'https://www.cetravets.com/cookie-policy-privacy-policy',

    upgradeImages: {
        paywall: {
            clinic: require('./assets/banners/ctaUpgradeClinicPaywall.png'),
            professional: require('./assets/banners/ctaUpgradeProfessionalPaywall.png'),
        },
        settings: {
            clinic: {
                desktop: require('./assets/banners/ctaUpgradeClinic.png'),
                mobile: require('./assets/banners/ctaUpgradeClinicMobile.png'),
            },
            professional: {
                desktop: require('./assets/banners/ctaUpgradeProfessional.png'),
                mobile: require('./assets/banners/ctaUpgradeProfessionalMobile.png'),
            },
            trial: {
                desktop: require('./assets/banners/ctaUpgradeTrial.png'),
                mobile: require('./assets/banners/ctaUpgradeTrialMobile.png'),
            },
        },
    },

    practiceOrClinicText: 'practice',

    anatomyStuffPostersUrl: 'https://www.anatomystuff.co.uk/collections/veterinary-posters-animal-anatomy-charts',

    // annualDiscountText: 'Save 5% with annual plans',
};

export const getCTAUpgradeImageUrl = (type) => {
    return config.upgradeImages.paywall[type];
};

export const getCTAUpgradeSettingsImageUrl = (planType, isMobile = false) => {
    const viewPort = isMobile ? 'mobile' : 'desktop';
    return config.upgradeImages.settings[planType][viewPort];
};

export const cetraBlueLogo = config.cetraBlueLogo;
export const cetraMobileLogo = config.cetraMobileLogo;
export const feedbackMessage = config.feedbackText;
export const landingPageUrl = config.landingPageUrl;
export const surveyUrl = config.surveyUrl;
export const tsCsUrl = config.tsCsUrl;
export const privacyPolicyUrl = config.privacyPolicyUrl;
export const practiceOrClinicText = config.practiceOrClinicText;
export const anatomyStuffPostersUrl = config.anatomyStuffPostersUrl;

export default config;
